import React from "react";
import Chart from "react-apexcharts";

const BarChart = ({ data }) => {
    if (!data) {
        return <div>Loading...</div>;
    }
    const chartData = {
        series: data.series,
        options: {
            chart: {
                type: "bar",
                toolbar: {
                    show: true,
                    tools: {
                        download: false, // ❌ removes download option
                    },
                },
                animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150,
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 550,
                    },
                },
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: "12px"
                },
                theme: "dark", // base theme
            },
            title: {
                text: data.options.title.text,
                align: "center",
                style: {
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "white", // Title text color
                },
            },
            xaxis: {
                categories: data.options.xaxis.categories,
                labels: {
                    style: {
                        colors: "white",   // X-axis text color
                        fontSize: "12px",
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        colors: "white",   // Y-axis text color
                        fontSize: "12px",
                    },
                },
            },
            dataLabels: {
                enabled: false,
            },

        },
    };

    return (
        <Chart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={350}
        />
    );
};

export default BarChart;
